import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
// Socket
import { Socket } from 'ng-socket-io';
// Helper
import { Helper } from '../helpers/helper';
// tslint:disable-next-line:import-blacklist
import 'rxjs/Rx';

@Injectable()
export class PrestamosService {

  constructor(private http: HttpClient, private helper: Helper, private socket: Socket) { }

  // Obtener lista de cedulas clientes
  obtenerRncClientes() {
    return this.http.get(`${this.helper.urlServer}/api/v1/rnc-clientes`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) }).map((res: any) => res);
  }

  obtenerDiasFeriados() {
    return this.http.get(`${this.helper.urlServer}/api/v1/dias-feriados`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) }).map((res: any) => res);
  }

  // Registrar prestamo
  registrarNuevoPrestamo(formCliente: any, formPrestamo: any, tablaAmortizacion: Array<any>): Observable<any> {
    if (!formPrestamo.gastoCierre) {
      formPrestamo.gastoCierre = 0;
    }
    return this.http.post(`${this.helper.urlServer}/api/v1/registrar-prestamo`,
      {formCliente, formPrestamo, cuotas: tablaAmortizacion},
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  calcularGastoCierre(data) {
    switch (data.tipo) {
      case 1: return data.monto_gasto_cierre;
      case 2: return data.capital_prestamo * (data.monto_gasto_cierre / 100);
      default:
        return Math.ceil(data.capital_prestamo / data.monto_incremento) * data.monto_gasto_cierre;
    }
  }

  obtenerDetallePrestamo(ID_PRESTAMO: string) {
    return this.http.get(`${this.helper.urlServer}/api/v1/detalle-prestamo/${ID_PRESTAMO}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  aprobarPrestamo(prestamo: any) {
    return this.http.put(`${this.helper.urlServer}/api/v1/aprobar-prestamo`, prestamo,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  denegarPrestamo(ID_PRESTAMO: string, estado, ID_EMPLEADO: string, razon: string, cliente_id?) {
    const data = {
      ID_PRESTAMO,
      ID_EMPLEADO,
      razon,
      estado,
      cliente_id
    };

    return this.http.put(`${this.helper.urlServer}/api/v1/denegar-prestamo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  obtenerTableroPrestamo(estado = '1', rutas?, fecha = '', renovacion = '0') {
    let params = new HttpParams();
    params = params.append('estado', estado);
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    params = params.append('fecha', fecha);
    params = params.append('renovacion', renovacion);
    return this.http.get(`${this.helper.urlServer}/api/v1/tablero-prestamo`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  obtenerTableroExtraordinario(rutas?, fecha = '') {
    let params = new HttpParams();
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    params = params.append('fecha', fecha);
    return this.http.get(`${this.helper.urlServer}/api/v1/tablero-extraordinario`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

   // Se le agregó 'estado = 400' para no mostrar resultados
  obtenerListaPrestamos(estado = '400', fecha_desde?, fecha_hasta?, rutas?, limit?, offset?, nc?, tipo?, orders?, region?, subregion?) {
    let params = new HttpParams();
    params = params.append('estado', String(estado));
    params = params.append('tipo', tipo);
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (region) {
      params = params.append('region', region);
    }
    if (subregion) {
      params = params.append('subregion', subregion);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (nc) {
      params = params.append('nc', nc);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-prestamos`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params}).map((res: any) => res);
  }

  realizarPago(data, isArr = true) {
    if (isArr) {
      return this.http.post(`${this.helper.urlServer}/api/v1/pagar-cuotas`, data,
      {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);

    } else {
      return this.http.post(`${this.helper.urlServer}/api/v1/pagar-cuota`, data,
      {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);

    }
  }

  obtenerTableroPagosAlDia(rutas?, fecha = '') {
    let params = new HttpParams();
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    params = params.append('fecha', fecha);
    return this.http.get(`${this.helper.urlServer}/api/v1/tablero-pagos-al-dia`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  obtenerTableroPagosAtrasos(rutas?, fecha = '') {
    let params = new HttpParams();
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    params = params.append('fecha', fecha);
    return this.http.get(`${this.helper.urlServer}/api/v1/tablero-pagos-atrasos`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  obtenerTableroPagosVencidos(rutas?, fecha = '') {
    let params = new HttpParams();
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    params = params.append('fecha', fecha);
    return this.http.get(`${this.helper.urlServer}/api/v1/tablero-pagos-vencidos`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  obtenerPrestamoParaEditar(ID_PRESTAMO) {
    return this.http.get(`${this.helper.urlServer}/api/v1/datos-prestamo/${ID_PRESTAMO}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  editarPrestamo(formCliente: any, formPrestamo: any, tablaAmortizacion: Array<any>): Observable<any> {

    return this.http.put(`${this.helper.urlServer}/api/v1/editar-prestamo`,
      {formCliente, formPrestamo, cuotas: tablaAmortizacion},
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  obtenerListaRecibos(limit?, offset?, rutas?, busqueda?, fecha_desde?, fecha_hasta?, estado?, prestamo_id?, ID_RECIBO?, orders?) {
    let params = new HttpParams();

    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (busqueda) {
      params = params.append('busqueda', busqueda);
    }
    if (fecha_desde) {
      params = params.append('fecha_desde', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_hasta', fecha_hasta);
    }
    if (estado !== -1 && estado >= 0) {
      params = params.append('estado', estado);
    }
    if (prestamo_id) {
      params = params.append('id', prestamo_id);
    }
    if (ID_RECIBO) {
      params = params.append('recibo', ID_RECIBO);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-recibos`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  obtenerListaNotaCreditoCuotas(limit?, offset?, ruta?, recibo?, fecha?, estado?, prestamo_id?, ID_RECIBO?) {
    let params = new HttpParams();
    if (limit) {

      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (ruta) {
      params = params.append('ruta', ruta);
    }
    if (recibo) {

      params = params.append('recibo', recibo);
    }
    if (fecha) {
      params = params.append('fecha', fecha);
    }
    if (estado !== -1 && estado >= 0) {

      params = params.append('estado', estado);
    }
    if (prestamo_id) {
      params = params.append('id', prestamo_id);
    }
    if (ID_RECIBO) {
      params = params.append('recibo', ID_RECIBO);
    }

    return this.http.get(`${this.helper.urlServer}/api/v1/lista-notas-credito-cuotas`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  obtenerDetalleRecibo(ID_RECIBO, ID_PRESTAMO) {
    let params = new HttpParams();
    params = params.append('recibo', ID_RECIBO);
    params = params.append('prestamo', ID_PRESTAMO);
    return this.http.get(`${this.helper.urlServer}/api/v1/detalle-recibo`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }

  obtenerDetalleNotaCredito(NO_CUENTA, ID_PRESTAMO) {

    console.log(NO_CUENTA);

    let params = new HttpParams();
    params = params.append('cuenta', NO_CUENTA);
    params = params.append('ID_PRESTAMO', ID_PRESTAMO);
    return this.http.get(`${this.helper.urlServer}/api/v1/detalle-nota-credito`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }

  obtenerListaMovimientosPrestamos(ID_PRESTAMO, compania) {
    let params = new HttpParams();
    params = params.append('prestamo', ID_PRESTAMO);
    params = params.append('compania', compania);
    return this.http.get(`${this.helper.urlServer}/api/v1/mvts-de-prestamo`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  obtenerCobros(limit?, offset?, rutas?, ce?, fecha_desde?, fecha_hasta?, orders?, incluir?) {
    let params = new HttpParams();
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (ce) {
      params = params.append('ce', ce);
    }
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    if (incluir) {
      params = params.append('incluir', incluir);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-pagos`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }

  // Para obtener la lista de cobros en el día (quien pago y quien no)
  obtenerListaCobrosDia(limit?, offset?, ruta?, ce?, fecha?, pagos?, notas?, incluir?, orders?) {
    let params = new HttpParams();
    if (orders) { //Columnas de la tabla y orden
      params = params.append('orders', orders);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (ruta) { // Busca registros por ruta
      params = params.append('ruta',ruta) ;
    }
    if (ce) { // Busca registros por nombre|cobrador
      params = params.append('ce', ce);
    }
    if (fecha) { // Busca registros por fecha
      params = params.append('fecha', fecha);
    }
    if (pagos) { // Busca registros por pagos/nopagos/todos
      params = params.append('pagos', pagos);
    }
    if (notas) {
      params = params.append('notas', notas);
    }
    if (incluir) { // Mostrar prestamos: Activos, vencidos o incobrables
      params = params.append('incluir', incluir);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-cobros-del-dia`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }

  obtenerProyeccion(fecha_desde?, fecha_hasta?, rutas?, empleado?, orders?) {
    let params = new HttpParams();
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (empleado) {
      params = params.append('empleado', empleado);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/proyeccion`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  reporteRecibos(ruta?, fecha?, estado?) {
    let params = new HttpParams();

    if (ruta) {
      params = params.append('ruta', ruta);
    }
    if (fecha) {
      params = params.append('fecha', fecha);
    }
    if (estado) {
      params = params.append('estado', estado);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-recibos`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  registrarRecibo(data) {
    return this.http.post(`${this.helper.urlServer}/api/v1/registrar-recibo-web`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);
  }

  anularRecibo(data) {
    return this.http.post(`${this.helper.urlServer}/api/v1/anular-recibo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);
  }

  obtenerTableroPagos(rutas?, fecha = '') {
    let params = new HttpParams();
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    params = params.append('fecha', fecha);
    return this.http.get(`${this.helper.urlServer}/api/v1/tablero-pagos`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  // obtener los prestamos activos del cliente
  obtenerListaPrestamosCliente(id: number) {
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-prestamos-cliente/${ id }`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  obtenerConfiguracionPrestamo( ID_RUTA = 0) {
    return this.http.get(`${this.helper.urlServer}/api/v1/configuracion-prestamo/${ID_RUTA}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  configurarPrestamo(data, ID_RUTA = 0 ) {
    Object.defineProperty(data, 'ID_RUTA', { value: ID_RUTA, enumerable: true});
    return this.http.put(`${this.helper.urlServer}/api/v1/configurar-prestamo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);
  }

  obtenerPrestamosCuotasVencidas(limit?, offset?, ruta?, cuotas?, operador?, incluir?, rutas?, empleado?, orders?) {
    let params = new HttpParams();
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (ruta) {
      params = params.append('ruta', ruta);
    }
    if (cuotas) {
      params = params.append('cuotas', cuotas);
    }
    if (operador) {
      params = params.append('operador', operador);
    }
    if (incluir) {
      params = params.append('incluir', incluir);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (empleado) {
      params = params.append('empleado', empleado);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/prestamos-con-cuotas-vencidas`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  /**
   * Actualizar cuotas para hacer una Notas de créditos / Descuentar cuotas
   * @author Pedro Reinoso
   */
  descuentoCuotas(data, detalle, documentos: any[]) {
    data.detalle = detalle;
    const formData = new FormData();
    // tslint:disable-next-line:forin
    for (const i in documentos) {
      formData.append('files[]', documentos[i].value._file);
      formData.append('documentos[]', JSON.stringify(documentos[i].value));
    }
    formData.append('data', JSON.stringify(data));
    return this.http.put(`${this.helper.urlServer}/api/v1/descontar-cuota`, formData,
    {headers: this.helper.getHeaderFiles(localStorage.getItem('token'))}).timeout(5000);
  }

  obtenerReporteGlobalSemanal(fechas?) {
    let params = new HttpParams();

    // console.log( 'SERV ' + incluir );

    if (fechas) {
      const fecha_inicia = fechas.beginDate.year + '-' + fechas.beginDate.month + '-' + fechas.beginDate.day;
      const fecha_termina = fechas.endDate.year + '-' + fechas.endDate.month + '-' + fechas.endDate.day;
      params = params.append('fecha_inicia', fecha_inicia);
      params = params.append('fecha_termina', fecha_termina);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-semanal-rutas`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }

  detalleRecibo(ID_RECIBO) {
    return this.http.get(`${this.helper.urlServer}/api/v1/recibo/${ID_RECIBO}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  detalleNotasCreditoCuota(ID_RECIBO) {
    return this.http.get(`${this.helper.urlServer}/api/v1/recibo/${ID_RECIBO}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  // tslint:disable-next-line:max-line-length
  obtenerControlCobros(limit?, offset?, rutas?, ce?, fecha?, listaMostrar?, operador?, operadorEntre?, operadorA?, orders?, operadorFecha?, incluir?, operadorEntreC?, operadorHastaC?) {
    let params = new HttpParams();
    params = params.append('operador_fecha', operadorFecha);
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (rutas) { // Busca registros por rutas
      params = params.append('rutas', rutas);
    }
    if (ce) { // Busca registros por nombre|cobrador
      params = params.append('cliente', ce);
    }
    if (fecha) { // Busca registros por fecha
      params = params.append('fecha', fecha);
    }
    if (listaMostrar) { // Busca registros por fecha
      params = params.append('lista_mostrar', listaMostrar);
    }
    if (operador) { // Busca registros por operador
      params = params.append('operador', operador);
    }
    if (operadorEntre) { // Busca registros por operador
      params = params.append('operador_entre', operadorEntre);
    }
    if (operadorA) { // Busca registros por operador
      params = params.append('operador_a', operadorA);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    if (incluir) {
      params = params.append('incluir', incluir);
    }
    if (operadorEntreC) { // Busca registros por operador
      params = params.append('desde_cuotas', operadorEntreC);
    }
    if (operadorHastaC) { // Busca registros por operador
      params = params.append('hasta_cuotas', operadorHastaC);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/control-cobros`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }

  anularMoraPrestamo(ID_PRESTAMO: number, tipo: number) {
    const data = {
      ID_PRESTAMO,
      tipo
    };

    return this.http.put(`${this.helper.urlServer}/api/v1/anular-mora-prestamo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  incluirMoraPrestamo(ID_PRESTAMO: any) {
    const data = {
      ID_PRESTAMO
    };
    return this.http.put(`${this.helper.urlServer}/api/v1/incluir-mora-prestamo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  anularMoraCuota(cuota) {
    return this.http.put(`${this.helper.urlServer}/api/v1/anular-mora-cuota`, cuota,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  pausarReaundaMoraPrestamo(data) {
    return this.http.put(`${this.helper.urlServer}/api/v1/pausar-mora-prestamo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  obtenerListaPresolicitudesPrestamos(estado = -1, fecha_desde?, fecha_hasta?, rutas?, limit?, offset?, nc?, ID?, orders?, solicitud?) {
    let params = new HttpParams();
    params = params.append('estado', String(estado));
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (nc) {
      params = params.append('nc', nc);
    }
    if (solicitud) {
      params = params.append('solicitud', solicitud);
    }
    if (ID) {
      params = params.append('ID', ID);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-pre-solicitudes`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params}).map((res: any) => res);
  }

  actualizarEstadoPresolicitud(data) {
    return this.http.put(`${this.helper.urlServer}/api/v1/actualizar-estado-pre-solicitud-prestamo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  actualizarCapitalPresolicitud(data) {
    return this.http.put(`${this.helper.urlServer}/api/v1/actualizar-capital-pre-solicitud-prestamo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  eliminarPrestamo(ID_PRESTAMO, razon) {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`${this.helper.urlServer}/api/v1/eliminar-prestamo`, { ID_PRESTAMO, razon }, {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  historialPagos(ID_PRESTAMO) {
    return this.http.get(`${this.helper.urlServer}/api/v1/historial-pagos-prestamo/${ID_PRESTAMO}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).map((res: any) => res);
  }

  obtenerProyeccionDetallada(fecha_desde?, fecha_hasta?, rutas?, empleado?, limit?, offset?) {
    let params = new HttpParams();
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (empleado) {
      params = params.append('empleado', empleado);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/proyeccion-detalle`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  obtenerAnticipos(fecha_desde?, fecha_hasta?, rutas?, empleado?, limit?, offset?, orders?) {
    let params = new HttpParams();
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (empleado) {
      params = params.append('empleado', empleado);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/anticipos-por-ruta`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  quickDetailLoan(ID) {
    return this.http.get(`${this.helper.urlServer}/api/v1/quick-detail-loan/${ID}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  anularMoraTodos() {
    return this.http.get(`${this.helper.urlServer}/api/v1/anular-mora-prestamos`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/prestamos.service.ts